import Button from "@mui/material/Button"
import { useTheme } from "@mui/material/styles"
const GrayButton = (props) => {
  const { sx } = props
  const theme = useTheme()

  return (
    <Button
      variant="contained"
      color="gray"
      disableElevation={true}
      {...props}
      sx={{
        mt: 4,
        height: "54px",
        textTransform: "none",
        whiteSpace: "nowrap",
        borderRadius: 10,
        fontWeight: 700,
        fontSize: theme.direction === "rtl" ? "18px" : "16px",
        ...sx,
      }}
    >
      {props.text}
    </Button>
  )
}

export default GrayButton
